/**
 * Search
 */

import SelectorEngine from '../../../shared/dom/selector-engine';
import Manipulator from '../../../shared/dom/manipulator';
import EventHandler from '../../../shared/dom/event-handler';
import Data from '../../../shared/dom/data';

import jQuery from 'jquery';
import './vendor/jquery.autocomplete.min';
import SuggestController from './vendor/suggest_controller';

import Drawer from '../../../shared/components/drawer';

// -------
// Privat
// -------

const NAME      = 'search';
const DATA_KEY  = `ifab.${NAME}`;
const EVENT_KEY = `.${DATA_KEY}`;
// const API_KEY    = '.data-api';

let searchForm = null;
let searchField = null;
let searchFieldMinlength;

const setupSearchForm = async (init = false) => {
	if (!init) {
		return;
	}

	const searchStorage = sessionStorage.getItem(`${window.pageInstance.prefix}search`);
	const storageSearchData = (searchStorage) ? JSON.parse(searchStorage) : {};

	const submitButton = SelectorEngine.findOne('button[type="submit"]', searchForm);

	searchFieldMinlength = parseInt(searchField.getAttribute('minlength') ?? 3, 10);

	if (storageSearchData.phrase) {
		searchField.value = storageSearchData.phrase.trim();
	}

	// Formular-Submit prüfen.
	EventHandler.on(searchForm, 'submit', event => {
		console.log('submit');
		if (Data.get(searchForm, 'searchEnabled') !== true) {
			event.preventDefault();
			event.stopPropagation();
		}
	});

	// Formular prüfen auf aktiv oder inaktiv.
	EventHandler.on(searchForm, 'search.handleSubmit', () => {
		if (searchField.value !== '' && searchField.value.length >= searchFieldMinlength) {
			Data.set(searchForm, 'searchEnabled', true);
			Manipulator.setDisabled(submitButton, false);

			storageSearchData.phrase = searchField.value.trim();

			sessionStorage.setItem(`${window.pageInstance.prefix}search`, JSON.stringify(storageSearchData));
		} else {
			Data.set(searchForm, 'searchEnabled', false);
			Manipulator.setDisabled(submitButton);
		}
	});

	// Eingabefeld: bei Eingabe Formular prüfen
	EventHandler.on(searchField, 'keyup', () => {
		EventHandler.trigger(searchForm, 'search.handleSubmit');
	});

	// Eingabefeld: wenn per Klick ´geleert´, dann Formular prüfen
	EventHandler.on(searchField, 'clearable.clear', () => {
		EventHandler.trigger(searchForm, 'search.handleSubmit');
	});

	// Formular prüfen
	EventHandler.trigger(searchForm, 'search.handleSubmit');

	// Solr Suggest initialisieren
	if (searchForm.hasAttribute('data-suggest')) {
		const solrSuggestController = new SuggestController();
		solrSuggestController.init();
	}

	// Wenn wir uns auf der Suchseite befinden, muss der Seitentitel um den Suchbegriff erweitert werden.
	if (Manipulator.getDataAttribute(document.body, 'page-type') === 'search') {
		const pageTitleSubheader = SelectorEngine.findOne('.page-title .page-title__subheader') ?? null;

		if (pageTitleSubheader && searchField.value !== '') {
			pageTitleSubheader.dataset.searchQuery = searchField.value.trim();
		}
	}
};

/**
 * Drawer ´Search´
 */
const setupDrawer = async (init = false) => {
	const ctrls = SelectorEngine.find('[aria-controls="search-drawer"]');

	let drawerApi;

	if (init) {
		const drawerContainer = SelectorEngine.findOne('#search-drawer');

		if (!drawerContainer) {
			for (const ctrl of ctrls) {
				Manipulator.setDisabled(ctrl, true);
			}

			return;
		}

		drawerApi = await new Drawer(drawerContainer, {
			closeButton: false,
			noHeader   : true,
			onShow     : function () {
				for (const ctrl of ctrls) {
					Manipulator.addClass(ctrl, '_active');
				}

				searchField.focus();
			},
			onHidden   : () => {
				for (const ctrl of ctrls) {
					Manipulator.removeClass(ctrl, '_active');
				}
			}
		});
	}

	for (const ctrl of ctrls) {
		if (init && drawerApi) {
			EventHandler.on(ctrl, `click${EVENT_KEY}`, (event) => {
				event.preventDefault();
				event.stopPropagation();

				if (event.delegateTarget.classList.contains('-active')) {
					drawerApi.hide();
				} else {
					// if (window.drawer.menu) {
					// 	window.drawer.next = drawerApi;
					// 	window.drawer.menu.hide();
					// } else {
					// 	drawerApi.show();
					// }

					drawerApi.show();
				}
			});
		} else {
			Manipulator.setDisabled(ctrl);
		}
	}
};

// -------
// Public
// -------

const search = async () => {
	searchForm  = SelectorEngine.findOne('.search-box form') ?? null;
	searchField = searchForm ? SelectorEngine.findOne('.search-box__input', searchForm) : null;

	await setupSearchForm(!!searchField);
	await setupDrawer(!!searchField);

	return searchForm;
};

// Export
export default search;
